/** @file English catalog part of area E7 (W3-03); replaced whole by that area. */

/** The `restore`, `trashedOn`, `purge` and `confirmPurge` keys (spread into `projects`). S0 composes it into `en`. */
export const projectsExtraEn = { restore: 'Restore', trashedOn: 'trashed {date}', purge: 'Delete forever', confirmPurge: 'Click again to delete {name} forever' } as const;
